import React, { useEffect, useState, useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, withRouter } from "react-router-dom";
import { CircularProgress } from "@material-ui/core";
import BusinessProfile from "~/components/businessProfile";
import businessService from "~/services/businessService";
import businessAction from "~/store/actions/businessAction";
import { DialogBuilder } from "~/utils/DialogProvider";
import { useTranslation } from "react-i18next";
import { mixpanelTrackEvent } from "~/utils/mixpanel";
import languageHelper from "~/helpers/language";
import _ from "lodash";

const BusinessProfilePage = (props) => {
	const { t } = useTranslation();
	const dispatch = useDispatch();
	const { id } = useParams();

	const meStore = useSelector((store) => store.me);
	const { business } = useSelector((store) => store.business);
	const dialog = useContext(DialogBuilder);

	const [loading, setLoading] = useState(false);

	const loadBusiness = async () => {
		setLoading(true);
		try {
			const res = await businessService.getBusiness(id);
			dispatch(businessAction.setBusiness(res.data));

			let eventProps = {};
			if (!_.isEmpty(res.data?.language)) {
				eventProps = { Idioma: languageHelper.translate(res.data?.language) };
			}
			mixpanelTrackEvent("Visualizou_Perfil_Business", eventProps, meStore?.me || {}, res.data || {});
			
			setLoading(false);
		} catch (err) {
			dialog
				.withMessage(err?.response?.data?.message || t("Unable to load business information"))
				.withButtonText(t("Try again"))
				.withAction(() => {
					loadBusiness();
				})
				.show();
			setLoading(false);
		}
	};

	useEffect(() => {
		if (!business || business.id !== id) {
			loadBusiness();
		}
	}, [id]);

	if (loading) {
		return (
			<div
				style={{
					display: "flex",
					justifyContent: "center",
					alignItems: "center",
					height: "100vh",
				}}
			>
				<CircularProgress />
			</div>
		);
	}

	return <BusinessProfile business={business} />;
};

export default withRouter(BusinessProfilePage);

